import { IconConfig } from '../icon-config.interface';

export const HeroEdit: IconConfig = {
  name: 'hero-edit',
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
</svg>
`
};

export const HeroAcademicCap: IconConfig = {
  name: `academic-cap`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path d="M12 14l9-5-9-5-9 5 9 5z"/>
  <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"/>
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"/>
</svg>
`
};
export const HeroAdjustments: IconConfig = {
  name: `adjustments`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"/>
</svg>
`
};
export const HeroAnnotation: IconConfig = {
  name: `annotation`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"/>
</svg>
`
};
export const HeroArchive: IconConfig = {
  name: `archive`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"/>
</svg>
`
};
export const HeroArrowCircleDown: IconConfig = {
  name: `arrow-circle-down`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z"/>
</svg>
`
};
export const HeroArrowCircleLeft: IconConfig = {
  name: `arrow-circle-left`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"/>
</svg>
`
};
export const HeroArrowCircleRight: IconConfig = {
  name: `arrow-circle-right`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroArrowCircleUp: IconConfig = {
  name: `arrow-circle-up`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 11l3-3m0 0l3 3m-3-3v8m0-13a9 9 0 110 18 9 9 0 010-18z"/>
</svg>
`
};
export const HeroArrowDown: IconConfig = {
  name: `arrow-down`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"/>
</svg>
`
};
export const HeroArrowLeft: IconConfig = {
  name: `arrow-left`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
</svg>
`
};
export const HeroArrowNarrowDown: IconConfig = {
  name: `arrow-narrow-down`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3"/>
</svg>
`
};
export const HeroArrowNarrowLeft: IconConfig = {
  name: `arrow-narrow-left`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16l-4-4m0 0l4-4m-4 4h18"/>
</svg>
`
};
export const HeroArrowNarrowRight: IconConfig = {
  name: `arrow-narrow-right`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3"/>
</svg>
`
};
export const HeroArrowNarrowUp: IconConfig = {
  name: `arrow-narrow-up`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18"/>
</svg>
`
};
export const HeroArrowRight: IconConfig = {
  name: `arrow-right`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"/>
</svg>
`
};
export const HeroArrowSmDown: IconConfig = {
  name: `arrow-sm-down`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 13l-5 5m0 0l-5-5m5 5V6"/>
</svg>
`
};
export const HeroArrowSmLeft: IconConfig = {
  name: `arrow-sm-left`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 17l-5-5m0 0l5-5m-5 5h12"/>
</svg>
`
};
export const HeroArrowSmRight: IconConfig = {
  name: `arrow-sm-right`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
</svg>
`
};
export const HeroArrowSmUp: IconConfig = {
  name: `arrow-sm-up`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 11l5-5m0 0l5 5m-5-5v12"/>
</svg>
`
};
export const HeroArrowUp: IconConfig = {
  name: `arrow-up`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"/>
</svg>
`
};
export const HeroArrowsExpand: IconConfig = {
  name: `arrows-expand`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"/>
</svg>
`
};
export const HeroAtSymbol: IconConfig = {
  name: `at-symbol`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"/>
</svg>
`
};
export const HeroBackspace: IconConfig = {
  name: `backspace`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z"/>
</svg>
`
};
export const HeroBadgeCheck: IconConfig = {
  name: `badge-check`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"/>
</svg>
`
};
export const HeroBan: IconConfig = {
  name: `ban`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/>
</svg>
`
};
export const HeroBeaker: IconConfig = {
  name: `beaker`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"/>
</svg>
`
};
export const HeroBell: IconConfig = {
  name: `bell`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
</svg>
`
};
export const HeroBookOpen: IconConfig = {
  name: `book-open`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
</svg>
`
};
export const HeroBookmarkAlt: IconConfig = {
  name: `bookmark-alt`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 4v12l-4-2-4 2V4M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
</svg>
`
};
export const HeroBookmark: IconConfig = {
  name: `bookmark`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"/>
</svg>
`
};
export const HeroBriefcase: IconConfig = {
  name: `briefcase`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
</svg>
`
};
export const HeroCake: IconConfig = {
  name: `cake`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 15.546c-.523 0-1.046.151-1.5.454a2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.701 2.701 0 00-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-7a2 2 0 00-2-2H5a2 2 0 00-2 2v7h18zm-3-9v-2a2 2 0 00-2-2H8a2 2 0 00-2 2v2h12z"/>
</svg>
`
};
export const HeroCalculator: IconConfig = {
  name: `calculator`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"/>
</svg>
`
};
export const HeroCalendar: IconConfig = {
  name: `calendar`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
</svg>
`
};
export const HeroCamera: IconConfig = {
  name: `camera`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"/>
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"/>
</svg>
`
};
export const HeroCash: IconConfig = {
  name: `cash`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"/>
</svg>
`
};
export const HeroChartBar: IconConfig = {
  name: `chart-bar`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
</svg>
`
};
export const HeroChartPie: IconConfig = {
  name: `chart-pie`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"/>
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"/>
</svg>
`
};
export const HeroCustomers: IconConfig = {
  name: `customers`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-6 h-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
</svg>
`
};
export const HeroChartSquareBar: IconConfig = {
  name: `chart-square-bar`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
</svg>
`
};
export const HeroChatAlt2: IconConfig = {
  name: `chat-alt-2`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"/>
</svg>
`
};
export const HeroChatAlt: IconConfig = {
  name: `chat-alt`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"/>
</svg>
`
};
export const HeroChat: IconConfig = {
  name: `chat`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
</svg>
`
};
export const HeroCheckCircle: IconConfig = {
  name: `check-circle`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroCheck: IconConfig = {
  name: `check`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
</svg>
`
};
export const HeroChevronDoubleDown: IconConfig = {
  name: `chevron-double-down`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 13l-7 7-7-7m14-8l-7 7-7-7"/>
</svg>
`
};
export const HeroChevronDoubleLeft: IconConfig = {
  name: `chevron-double-left`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7"/>
</svg>
`
};
export const HeroChevronDoubleRight: IconConfig = {
  name: `chevron-double-right`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5l7 7-7 7M5 5l7 7-7 7"/>
</svg>
`
};
export const HeroChevronDoubleUp: IconConfig = {
  name: `chevron-double-up`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 11l7-7 7 7M5 19l7-7 7 7"/>
</svg>
`
};
export const HeroChevronDown: IconConfig = {
  name: `chevron-down`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
</svg>
`
};
export const HeroChevronLeft: IconConfig = {
  name: `chevron-left`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
</svg>
`
};
export const HeroChevronRight: IconConfig = {
  name: `chevron-right`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
</svg>
`
};
export const HeroChevronUp: IconConfig = {
  name: `chevron-up`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 15l7-7 7 7"/>
</svg>
`
};
export const HeroChip: IconConfig = {
  name: `chip`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"/>
</svg>
`
};
export const HeroClipboardCheck: IconConfig = {
  name: `clipboard-check`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
</svg>
`
};
export const HeroClipboardCopy: IconConfig = {
  name: `clipboard-copy`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3"/>
</svg>
`
};
export const HeroClipboardList: IconConfig = {
  name: `clipboard-list`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/>
</svg>
`
};
export const HeroClipboard: IconConfig = {
  name: `clipboard`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
</svg>
`
};
export const HeroClock: IconConfig = {
  name: `clock`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroCloudDownload: IconConfig = {
  name: `cloud-download`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10"/>
</svg>
`
};
export const HeroCloudUpload: IconConfig = {
  name: `cloud-upload`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
</svg>
`
};
export const HeroCloud: IconConfig = {
  name: `cloud`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"/>
</svg>
`
};
export const HeroCode: IconConfig = {
  name: `code`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"/>
</svg>
`
};
export const HeroCog: IconConfig = {
  name: `cog`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
</svg>
`
};
export const HeroCollection: IconConfig = {
  name: `collection`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
</svg>
`
};
export const HeroColorSwatch: IconConfig = {
  name: `color-swatch`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"/>
</svg>
`
};
export const HeroCreditCard: IconConfig = {
  name: `credit-card`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
</svg>
`
};
export const HeroCubeTransparent: IconConfig = {
  name: `cube-transparent`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 10l-2 1m0 0l-2-1m2 1v2.5M20 7l-2 1m2-1l-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1l2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"/>
</svg>
`
};
export const HeroCube: IconConfig = {
  name: `cube`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"/>
</svg>
`
};
export const HeroCurrencyBangladeshi: IconConfig = {
  name: `currency-bangladeshi`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 11V9a2 2 0 00-2-2m2 4v4a2 2 0 104 0v-1m-4-3H9m2 0h4m6 1a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroCurrencyDollar: IconConfig = {
  name: `currency-dollar`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroCurrencyEuro: IconConfig = {
  name: `currency-euro`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroCurrencyPound: IconConfig = {
  name: `currency-pound`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroCurrencyRupee: IconConfig = {
  name: `currency-rupee`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroCurrencyYen: IconConfig = {
  name: `currency-yen`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 8l3 5m0 0l3-5m-3 5v4m-3-5h6m-6 3h6m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroCursorClick: IconConfig = {
  name: `cursor-click`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"/>
</svg>
`
};
export const HeroDatabase: IconConfig = {
  name: `database`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"/>
</svg>
`
};
export const HeroDesktopComputer: IconConfig = {
  name: `desktop-computer`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
</svg>
`
};
export const HeroDeviceMobile: IconConfig = {
  name: `device-mobile`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"/>
</svg>
`
};
export const HeroDeviceTablet: IconConfig = {
  name: `device-tablet`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"/>
</svg>
`
};
export const HeroDocumentAdd: IconConfig = {
  name: `document-add`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m-3-3v6m5 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
</svg>
`
};
export const HeroDocumentDownload: IconConfig = {
  name: `document-download`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
</svg>
`
};
export const HeroDocumentDuplicate: IconConfig = {
  name: `document-duplicate`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"/>
</svg>
`
};
export const HeroDocumentRemove: IconConfig = {
  name: `document-remove`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
</svg>
`
};
export const HeroDocumentReport: IconConfig = {
  name: `document-report`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
</svg>
`
};
export const HeroDocumentSearch: IconConfig = {
  name: `document-search`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v11m0 5l4.879-4.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242z"/>
</svg>
`
};
export const HeroDocumentText: IconConfig = {
  name: `document-text`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
</svg>
`
};
export const HeroDocument: IconConfig = {
  name: `document`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"/>
</svg>
`
};
export const HeroDotsCircleHorizontal: IconConfig = {
  name: `dots-circle-horizontal`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroDotsHorizontal: IconConfig = {
  name: `dots-horizontal`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"/>
</svg>
`
};
export const HeroDotsVertical: IconConfig = {
  name: `dots-vertical`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"/>
</svg>
`
};
export const HeroDownload: IconConfig = {
  name: `download`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"/>
</svg>
`
};
export const HeroDuplicate: IconConfig = {
  name: `duplicate`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
</svg>
`
};
export const HeroEmojiHappy: IconConfig = {
  name: `emoji-happy`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroEmojiSad: IconConfig = {
  name: `emoji-sad`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroExclamationCircle: IconConfig = {
  name: `exclamation-circle`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroExclamation: IconConfig = {
  name: `exclamation`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
</svg>
`
};
export const HeroExternalLink: IconConfig = {
  name: `external-link`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"/>
</svg>
`
};
export const HeroEyeOff: IconConfig = {
  name: `eye-off`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"/>
</svg>
`
};
export const HeroEye: IconConfig = {
  name: `eye`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
</svg>
`
};
export const HeroFastForward: IconConfig = {
  name: `fast-forward`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.933 12.8a1 1 0 000-1.6L6.6 7.2A1 1 0 005 8v8a1 1 0 001.6.8l5.333-4zM19.933 12.8a1 1 0 000-1.6l-5.333-4A1 1 0 0013 8v8a1 1 0 001.6.8l5.333-4z"/>
</svg>
`
};
export const HeroFilm: IconConfig = {
  name: `film`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 4v16M17 4v16M3 8h4m10 0h4M3 12h18M3 16h4m10 0h4M4 20h16a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1z"/>
</svg>
`
};
export const HeroFilter: IconConfig = {
  name: `filter`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
</svg>
`
};
export const HeroFingerPrint: IconConfig = {
  name: `finger-print`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A13.916 13.916 0 008 11a4 4 0 118 0c0 1.017-.07 2.019-.203 3m-2.118 6.844A21.88 21.88 0 0015.171 17m3.839 1.132c.645-2.266.99-4.659.99-7.132A8 8 0 008 4.07M3 15.364c.64-1.319 1-2.8 1-4.364 0-1.457.39-2.823 1.07-4"/>
</svg>
`
};
export const HeroFire: IconConfig = {
  name: `fire`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.656 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z"/>
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z"/>
</svg>
`
};
export const HeroFlag: IconConfig = {
  name: `flag`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9"/>
</svg>
`
};
export const HeroFolderAdd: IconConfig = {
  name: `folder-add`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
</svg>
`
};
export const HeroFolderDownload: IconConfig = {
  name: `folder-download`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
</svg>
`
};
export const HeroFolderOpen: IconConfig = {
  name: `folder-open`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9a2 2 0 00-2 2v5a2 2 0 01-2 2z"/>
</svg>
`
};
export const HeroFolderRemove: IconConfig = {
  name: `folder-remove`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6M3 17V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
</svg>
`
};
export const HeroFolder: IconConfig = {
  name: `folder`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"/>
</svg>
`
};
export const HeroGift: IconConfig = {
  name: `gift`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"/>
</svg>
`
};
export const HeroGlobeAlt: IconConfig = {
  name: `globe-alt`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"/>
</svg>
`
};
export const HeroGlobe: IconConfig = {
  name: `globe`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroHand: IconConfig = {
  name: `hand`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"/>
</svg>
`
};
export const HeroHashtag: IconConfig = {
  name: `hashtag`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"/>
</svg>
`
};
export const HeroHeart: IconConfig = {
  name: `heart`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
</svg>
`
};
export const HeroHome: IconConfig = {
  name: `home`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
</svg>
`
};
export const HeroIdentification: IconConfig = {
  name: `identification`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"/>
</svg>
`
};
export const HeroInboxIn: IconConfig = {
  name: `inbox-in`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20"/>
</svg>
`
};
export const HeroInbox: IconConfig = {
  name: `inbox`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"/>
</svg>
`
};
export const HeroInformationCircle: IconConfig = {
  name: `information-circle`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroKey: IconConfig = {
  name: `key`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"/>
</svg>
`
};
export const HeroLibrary: IconConfig = {
  name: `library`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"/>
</svg>
`
};
export const HeroLightBulb: IconConfig = {
  name: `light-bulb`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
</svg>
`
};
export const HeroLightningBolt: IconConfig = {
  name: `lightning-bolt`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/>
</svg>
`
};
export const HeroLink: IconConfig = {
  name: `link`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
</svg>
`
};
export const HeroLocationMarker: IconConfig = {
  name: `location-marker`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
</svg>
`
};
export const HeroLockClosed: IconConfig = {
  name: `lock-closed`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
</svg>
`
};
export const HeroLockOpen: IconConfig = {
  name: `lock-open`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z"/>
</svg>
`
};
export const HeroLogin: IconConfig = {
  name: `login`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"/>
</svg>
`
};
export const HeroLogout: IconConfig = {
  name: `logout`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
</svg>
`
};
export const HeroMailOpen: IconConfig = {
  name: `mail-open`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 19v-8.93a2 2 0 01.89-1.664l7-4.666a2 2 0 012.22 0l7 4.666A2 2 0 0121 10.07V19M3 19a2 2 0 002 2h14a2 2 0 002-2M3 19l6.75-4.5M21 19l-6.75-4.5M3 10l6.75 4.5M21 10l-6.75 4.5m0 0l-1.14.76a2 2 0 01-2.22 0l-1.14-.76"/>
</svg>
`
};
export const HeroMail: IconConfig = {
  name: `mail`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
</svg>
`
};
export const HeroMap: IconConfig = {
  name: `map`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"/>
</svg>
`
};
export const HeroMenuAlt1: IconConfig = {
  name: `menu-alt-1`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16"/>
</svg>
`
};
export const HeroMenuAlt2: IconConfig = {
  name: `menu-alt-2`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h7"/>
</svg>
`
};
export const HeroMenuAlt3: IconConfig = {
  name: `menu-alt-3`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7"/>
</svg>
`
};
export const HeroMenuAlt4: IconConfig = {
  name: `menu-alt-4`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 8h16M4 16h16"/>
</svg>
`
};
export const HeroMenu: IconConfig = {
  name: `menu`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
</svg>
`
};
export const HeroMicrophone: IconConfig = {
  name: `microphone`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"/>
</svg>
`
};
export const HeroMinusCircle: IconConfig = {
  name: `minus-circle`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroMinusSm: IconConfig = {
  name: `minus-sm`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 12H6"/>
</svg>
`
};
export const HeroMinus: IconConfig = {
  name: `minus`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"/>
</svg>
`
};
export const HeroMoon: IconConfig = {
  name: `moon`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/>
</svg>
`
};
export const HeroMusicNote: IconConfig = {
  name: `music-note`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"/>
</svg>
`
};
export const HeroNewspaper: IconConfig = {
  name: `newspaper`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"/>
</svg>
`
};
export const HeroOfficeBuilding: IconConfig = {
  name: `office-building`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
</svg>
`
};
export const HeroPaperAirplane: IconConfig = {
  name: `paper-airplane`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>
</svg>
`
};
export const HeroPaperClip: IconConfig = {
  name: `paper-clip`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"/>
</svg>
`
};
export const HeroPause: IconConfig = {
  name: `pause`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 9v6m4-6v6m7-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroPencilAlt: IconConfig = {
  name: `pencil-alt`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
</svg>
`
};
export const HeroPencil: IconConfig = {
  name: `pencil`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"/>
</svg>
`
};
export const HeroPhoneIncoming: IconConfig = {
  name: `phone-incoming`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 3l-6 6m0 0V4m0 5h5M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"/>
</svg>
`
};
export const HeroPhoneMissedCall: IconConfig = {
  name: `phone-missed-call`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 8l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"/>
</svg>
`
};
export const HeroPhoneOutgoing: IconConfig = {
  name: `phone-outgoing`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 3h5m0 0v5m0-5l-6 6M5 3a2 2 0 00-2 2v1c0 8.284 6.716 15 15 15h1a2 2 0 002-2v-3.28a1 1 0 00-.684-.948l-4.493-1.498a1 1 0 00-1.21.502l-1.13 2.257a11.042 11.042 0 01-5.516-5.517l2.257-1.128a1 1 0 00.502-1.21L9.228 3.683A1 1 0 008.279 3H5z"/>
</svg>
`
};
export const HeroPhone: IconConfig = {
  name: `phone`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
</svg>
`
};
export const HeroPhotograph: IconConfig = {
  name: `photograph`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
</svg>
`
};
export const HeroPlay: IconConfig = {
  name: `play`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/>
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroPlusCircle: IconConfig = {
  name: `plus-circle`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroPlusSm: IconConfig = {
  name: `plus-sm`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
</svg>
`
};
export const HeroPlus: IconConfig = {
  name: `plus`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
</svg>
`
};
export const HeroPresentationChartBar: IconConfig = {
  name: `presentation-chart-bar`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 13v-1m4 1v-3m4 3V8M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"/>
</svg>
`
};
export const HeroPresentationChartLine: IconConfig = {
  name: `presentation-chart-line`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"/>
</svg>
`
};
export const HeroPrinter: IconConfig = {
  name: `printer`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"/>
</svg>
`
};
export const HeroPuzzle: IconConfig = {
  name: `puzzle`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z"/>
</svg>
`
};
export const HeroQrcode: IconConfig = {
  name: `qrcode`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"/>
</svg>
`
};
export const HeroQuestionMarkCircle: IconConfig = {
  name: `question-mark-circle`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroReceiptRefund: IconConfig = {
  name: `receipt-refund`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z"/>
</svg>
`
};
export const HeroReceiptTax: IconConfig = {
  name: `receipt-tax`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2zM10 8.5a.5.5 0 11-1 0 .5.5 0 011 0zm5 5a.5.5 0 11-1 0 .5.5 0 011 0z"/>
</svg>
`
};
export const HeroRefresh: IconConfig = {
  name: `refresh`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
</svg>
`
};
export const HeroReply: IconConfig = {
  name: `reply`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"/>
</svg>
`
};
export const HeroRewind: IconConfig = {
  name: `rewind`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0019 16V8a1 1 0 00-1.6-.8l-5.333 4zM4.066 11.2a1 1 0 000 1.6l5.334 4A1 1 0 0011 16V8a1 1 0 00-1.6-.8l-5.334 4z"/>
</svg>
`
};
export const HeroRss: IconConfig = {
  name: `rss`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 5c7.18 0 13 5.82 13 13M6 11a7 7 0 017 7m-6 0a1 1 0 11-2 0 1 1 0 012 0z"/>
</svg>
`
};
export const HeroSaveAs: IconConfig = {
  name: `save-as`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2h2m3-4H9a2 2 0 00-2 2v7a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-1m-1 4l-3 3m0 0l-3-3m3 3V3"/>
</svg>
`
};
export const HeroSave: IconConfig = {
  name: `save`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"/>
</svg>
`
};
export const HeroScale: IconConfig = {
  name: `scale`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3"/>
</svg>
`
};
export const HeroScissors: IconConfig = {
  name: `scissors`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.121 14.121L19 19m-7-7l7-7m-7 7l-2.879 2.879M12 12L9.121 9.121m0 5.758a3 3 0 10-4.243 4.243 3 3 0 004.243-4.243zm0-5.758a3 3 0 10-4.243-4.243 3 3 0 004.243 4.243z"/>
</svg>
`
};
export const HeroSearchCircle: IconConfig = {
  name: `search-circle`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16l2.879-2.879m0 0a3 3 0 104.243-4.242 3 3 0 00-4.243 4.242zM21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroSearch: IconConfig = {
  name: `search`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
</svg>
`
};
export const HeroSelector: IconConfig = {
  name: `selector`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l4-4 4 4m0 6l-4 4-4-4"/>
</svg>
`
};
export const HeroServer: IconConfig = {
  name: `server`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"/>
</svg>
`
};
export const HeroShare: IconConfig = {
  name: `share`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"/>
</svg>
`
};
export const HeroShieldCheck: IconConfig = {
  name: `shield-check`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
</svg>
`
};
export const HeroShieldExclamation: IconConfig = {
  name: `shield-exclamation`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016zM12 9v2m0 4h.01"/>
</svg>
`
};
export const HeroShoppingBag: IconConfig = {
  name: `shopping-bag`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
</svg>
`
};
export const HeroShoppingCart: IconConfig = {
  name: `shopping-cart`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
</svg>
`
};
export const HeroSortAscending: IconConfig = {
  name: `sort-ascending`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h6m4 0l4-4m0 0l4 4m-4-4v12"/>
</svg>
`
};
export const HeroSortDescending: IconConfig = {
  name: `sort-descending`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4h13M3 8h9m-9 4h9m5-4v12m0 0l-4-4m4 4l4-4"/>
</svg>
`
};
export const HeroSparkles: IconConfig = {
  name: `sparkles`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"/>
</svg>
`
};
export const HeroSpeakerphone: IconConfig = {
  name: `speakerphone`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"/>
</svg>
`
};
export const HeroStar: IconConfig = {
  name: `star`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"/>
</svg>
`
};
export const HeroStatusOffline: IconConfig = {
  name: `status-offline`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636a9 9 0 010 12.728m0 0l-2.829-2.829m2.829 2.829L21 21M15.536 8.464a5 5 0 010 7.072m0 0l-2.829-2.829m-4.243 2.829a4.978 4.978 0 01-1.414-2.83m-1.414 5.658a9 9 0 01-2.167-9.238m7.824 2.167a1 1 0 111.414 1.414m-1.414-1.414L3 3m8.293 8.293l1.414 1.414"/>
</svg>
`
};
export const HeroStatusOnline: IconConfig = {
  name: `status-online`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"/>
</svg>
`
};
export const HeroStop: IconConfig = {
  name: `stop`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 10a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"/>
</svg>
`
};
export const HeroSun: IconConfig = {
  name: `sun`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/>
</svg>
`
};
export const HeroSupport: IconConfig = {
  name: `support`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"/>
</svg>
`
};
export const HeroSwitchHorizontal: IconConfig = {
  name: `switch-horizontal`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"/>
</svg>
`
};
export const HeroSwitchVertical: IconConfig = {
  name: `switch-vertical`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"/>
</svg>
`
};
export const HeroTable: IconConfig = {
  name: `table`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"/>
</svg>
`
};
export const HeroTag: IconConfig = {
  name: `tag`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>
</svg>
`
};
export const HeroTemplate: IconConfig = {
  name: `template`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"/>
</svg>
`
};
export const HeroTerminal: IconConfig = {
  name: `terminal`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
</svg>
`
};
export const HeroThumbDown: IconConfig = {
  name: `thumb-down`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17 13V4m-7 10h2m5-10h2a2 2 0 012 2v6a2 2 0 01-2 2h-2.5"/>
</svg>
`
};
export const HeroThumbUp: IconConfig = {
  name: `thumb-up`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"/>
</svg>
`
};
export const HeroTicket: IconConfig = {
  name: `ticket`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"/>
</svg>
`
};
export const HeroTranslate: IconConfig = {
  name: `translate`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129"/>
</svg>
`
};
export const HeroTrash: IconConfig = {
  name: `trash`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
</svg>
`
};
export const HeroTrendingDown: IconConfig = {
  name: `trending-down`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 17h8m0 0V9m0 8l-8-8-4 4-6-6"/>
</svg>
`
};
export const HeroTrendingUp: IconConfig = {
  name: `trending-up`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
</svg>
`
};
export const HeroTruck: IconConfig = {
  name: `truck`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"/>
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"/>
</svg>
`
};
export const HeroUpload: IconConfig = {
  name: `upload`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"/>
</svg>
`
};
export const HeroUserAdd: IconConfig = {
  name: `user-add`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"/>
</svg>
`
};
export const HeroUserCircle: IconConfig = {
  name: `user-circle`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroUserGroup: IconConfig = {
  name: `user-group`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
</svg>
`
};
export const HeroUserRemove: IconConfig = {
  name: `user-remove`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6zM21 12h-6"/>
</svg>
`
};
export const HeroUser: IconConfig = {
  name: `user`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
</svg>
`
};
export const HeroUsers: IconConfig = {
  name: `users`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>
</svg>
`
};
export const HeroVariable: IconConfig = {
  name: `variable`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.871 4A17.926 17.926 0 003 12c0 2.874.673 5.59 1.871 8m14.13 0a17.926 17.926 0 001.87-8c0-2.874-.673-5.59-1.87-8M9 9h1.246a1 1 0 01.961.725l1.586 5.55a1 1 0 00.961.725H15m1-7h-.08a2 2 0 00-1.519.698L9.6 15.302A2 2 0 018.08 16H8"/>
</svg>
`
};
export const HeroVideoCamera: IconConfig = {
  name: `video-camera`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"/>
</svg>
`
};
export const HeroViewBoards: IconConfig = {
  name: `view-boards`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2"/>
</svg>
`
};
export const HeroViewGridAdd: IconConfig = {
  name: `view-grid-add`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 14v6m-3-3h6M6 10h2a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2zm10 0h2a2 2 0 002-2V6a2 2 0 00-2-2h-2a2 2 0 00-2 2v2a2 2 0 002 2zM6 20h2a2 2 0 002-2v-2a2 2 0 00-2-2H6a2 2 0 00-2 2v2a2 2 0 002 2z"/>
</svg>
`
};
export const HeroViewGrid: IconConfig = {
  name: `view-grid`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"/>
</svg>
`
};

export const HeroCalendarSecondary: IconConfig = {
  name: `calendar2`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" fill="#000000" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"></rect><rect x="40" y="40" width="176" height="176" rx="8" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></rect><line x1="176" y1="24" x2="176" y2="56" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="80" y1="24" x2="80" y2="56" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><line x1="40" y1="88" x2="216" y2="88" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></line><path d="M92,128h28l-16,20a16,16,0,1,1-11.3,27.3" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></path><polyline points="144 140 160 128 160 180" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline></svg>
`
};

export const HeroViewList: IconConfig = {
  name: `view-list`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"/>
</svg>
`
};
export const HeroVolumeOff: IconConfig = {
  name: `volume-off`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" clip-rule="evenodd"/>
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"/>
</svg>
`
};
export const HeroVolumeUp: IconConfig = {
  name: `volume-up`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"/>
</svg>
`
};
export const HeroWifi: IconConfig = {
  name: `wifi`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"/>
</svg>
`
};
export const HeroXCircle: IconConfig = {
  name: `x-circle`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>
</svg>
`
};
export const HeroX: IconConfig = {
  name: `x`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
</svg>
`
};
export const HeroZoomIn: IconConfig = {
  name: `zoom-in`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"/>
</svg>
`
};
export const HeroZoomOut: IconConfig = {
  name: `zoom-out`,
  src: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7"/>
</svg>
`
};
export const HeroInfoIcon: IconConfig = {
  name: `info-icon`,
  src: `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" stroke="#4B9CD3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9 12V9" stroke="#4B9CD3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9 6H9.00667" stroke="#4B9CD3" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`
};

export const HeroTrashIcon: IconConfig = {
  name: 'table-trash',
  src: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M3 6H5H21" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10 11V17" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14 11V17" stroke="#BDBDBD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`
};

export const HeroLockIcon: IconConfig = {
  name: 'lock-outlined',
  src: `<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.4583 7.79169H3.54167C2.75926 7.79169 2.125 8.42595 2.125 9.20835V14.1667C2.125 14.9491 2.75926 15.5834 3.54167 15.5834H13.4583C14.2407 15.5834 14.875 14.9491 14.875 14.1667V9.20835C14.875 8.42595 14.2407 7.79169 13.4583 7.79169Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M4.95801 7.79169V4.95835C4.95801 4.01905 5.33115 3.11821 5.99534 2.45402C6.65953 1.78983 7.56037 1.41669 8.49967 1.41669C9.43898 1.41669 10.3398 1.78983 11.004 2.45402C11.6682 3.11821 12.0413 4.01905 12.0413 4.95835V7.79169" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>`
};

export const HeroCompany: IconConfig = {
  name: `company`,
  src: `<svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
<path d="M6.41667 12.8333C6.41667 13.0764 6.32009 13.3096 6.14818 13.4815C5.97627 13.6534 5.74312 13.75 5.5 13.75H4.58333C4.34022 13.75 4.10706 13.6534 3.93515 13.4815C3.76324 13.3096 3.66667 13.0764 3.66667 12.8333C3.66667 12.5902 3.76324 12.3571 3.93515 12.1852C4.10706 12.0132 4.34022 11.9167 4.58333 11.9167H5.5C5.74312 11.9167 5.97627 12.0132 6.14818 12.1852C6.32009 12.3571 6.41667 12.5902 6.41667 12.8333ZM10.0833 11.9167H9.16667C8.92355 11.9167 8.69039 12.0132 8.51849 12.1852C8.34658 12.3571 8.25 12.5902 8.25 12.8333C8.25 13.0764 8.34658 13.3096 8.51849 13.4815C8.69039 13.6534 8.92355 13.75 9.16667 13.75H10.0833C10.3264 13.75 10.5596 13.6534 10.7315 13.4815C10.9034 13.3096 11 13.0764 11 12.8333C11 12.5902 10.9034 12.3571 10.7315 12.1852C10.5596 12.0132 10.3264 11.9167 10.0833 11.9167ZM5.5 15.5833H4.58333C4.34022 15.5833 4.10706 15.6799 3.93515 15.8518C3.76324 16.0237 3.66667 16.2569 3.66667 16.5C3.66667 16.7431 3.76324 16.9763 3.93515 17.1482C4.10706 17.3201 4.34022 17.4167 4.58333 17.4167H5.5C5.74312 17.4167 5.97627 17.3201 6.14818 17.1482C6.32009 16.9763 6.41667 16.7431 6.41667 16.5C6.41667 16.2569 6.32009 16.0237 6.14818 15.8518C5.97627 15.6799 5.74312 15.5833 5.5 15.5833ZM10.0833 15.5833H9.16667C8.92355 15.5833 8.69039 15.6799 8.51849 15.8518C8.34658 16.0237 8.25 16.2569 8.25 16.5C8.25 16.7431 8.34658 16.9763 8.51849 17.1482C8.69039 17.3201 8.92355 17.4167 9.16667 17.4167H10.0833C10.3264 17.4167 10.5596 17.3201 10.7315 17.1482C10.9034 16.9763 11 16.7431 11 16.5C11 16.2569 10.9034 16.0237 10.7315 15.8518C10.5596 15.6799 10.3264 15.5833 10.0833 15.5833ZM5.5 4.58333H4.58333C4.34022 4.58333 4.10706 4.67991 3.93515 4.85182C3.76324 5.02373 3.66667 5.25688 3.66667 5.5C3.66667 5.74312 3.76324 5.97627 3.93515 6.14818C4.10706 6.32009 4.34022 6.41667 4.58333 6.41667H5.5C5.74312 6.41667 5.97627 6.32009 6.14818 6.14818C6.32009 5.97627 6.41667 5.74312 6.41667 5.5C6.41667 5.25688 6.32009 5.02373 6.14818 4.85182C5.97627 4.67991 5.74312 4.58333 5.5 4.58333ZM10.0833 4.58333H9.16667C8.92355 4.58333 8.69039 4.67991 8.51849 4.85182C8.34658 5.02373 8.25 5.25688 8.25 5.5C8.25 5.74312 8.34658 5.97627 8.51849 6.14818C8.69039 6.32009 8.92355 6.41667 9.16667 6.41667H10.0833C10.3264 6.41667 10.5596 6.32009 10.7315 6.14818C10.9034 5.97627 11 5.74312 11 5.5C11 5.25688 10.9034 5.02373 10.7315 4.85182C10.5596 4.67991 10.3264 4.58333 10.0833 4.58333ZM5.5 8.25H4.58333C4.34022 8.25 4.10706 8.34658 3.93515 8.51849C3.76324 8.69039 3.66667 8.92355 3.66667 9.16667C3.66667 9.40978 3.76324 9.64294 3.93515 9.81485C4.10706 9.98676 4.34022 10.0833 4.58333 10.0833H5.5C5.74312 10.0833 5.97627 9.98676 6.14818 9.81485C6.32009 9.64294 6.41667 9.40978 6.41667 9.16667C6.41667 8.92355 6.32009 8.69039 6.14818 8.51849C5.97627 8.34658 5.74312 8.25 5.5 8.25ZM10.0833 8.25H9.16667C8.92355 8.25 8.69039 8.34658 8.51849 8.51849C8.34658 8.69039 8.25 8.92355 8.25 9.16667C8.25 9.40978 8.34658 9.64294 8.51849 9.81485C8.69039 9.98676 8.92355 10.0833 9.16667 10.0833H10.0833C10.3264 10.0833 10.5596 9.98676 10.7315 9.81485C10.9034 9.64294 11 9.40978 11 9.16667C11 8.92355 10.9034 8.69039 10.7315 8.51849C10.5596 8.34658 10.3264 8.25 10.0833 8.25ZM22 9.16667V17.4167C21.9985 18.6318 21.5152 19.7967 20.656 20.656C19.7967 21.5152 18.6318 21.9985 17.4167 22H4.58333C3.3682 21.9985 2.20326 21.5152 1.34403 20.656C0.484808 19.7967 0.00145554 18.6318 0 17.4167L0 4.58333C0.00145554 3.3682 0.484808 2.20326 1.34403 1.34403C2.20326 0.484808 3.3682 0.00145554 4.58333 0L10.0833 0C11.2985 0.00145554 12.4634 0.484808 13.3226 1.34403C14.1819 2.20326 14.6652 3.3682 14.6667 4.58333H17.4167C18.6318 4.58479 19.7967 5.06814 20.656 5.92737C21.5152 6.78659 21.9985 7.95154 22 9.16667V9.16667ZM4.58333 20.1667H12.8333V4.58333C12.8333 3.85399 12.5436 3.15451 12.0279 2.63879C11.5122 2.12306 10.8127 1.83333 10.0833 1.83333H4.58333C3.85399 1.83333 3.15451 2.12306 2.63879 2.63879C2.12306 3.15451 1.83333 3.85399 1.83333 4.58333V17.4167C1.83333 18.146 2.12306 18.8455 2.63879 19.3612C3.15451 19.8769 3.85399 20.1667 4.58333 20.1667ZM20.1667 9.16667C20.1667 8.43732 19.8769 7.73785 19.3612 7.22212C18.8455 6.7064 18.146 6.41667 17.4167 6.41667H14.6667V20.1667H17.4167C18.146 20.1667 18.8455 19.8769 19.3612 19.3612C19.8769 18.8455 20.1667 18.146 20.1667 17.4167V9.16667ZM17.4167 11.9167C17.2354 11.9167 17.0581 11.9704 16.9074 12.0712C16.7566 12.1719 16.6392 12.315 16.5698 12.4825C16.5004 12.65 16.4822 12.8344 16.5176 13.0122C16.553 13.19 16.6403 13.3533 16.7685 13.4815C16.8967 13.6097 17.06 13.697 17.2378 13.7324C17.4156 13.7678 17.6 13.7496 17.7675 13.6802C17.935 13.6108 18.0781 13.4934 18.1788 13.3426C18.2796 13.1919 18.3333 13.0146 18.3333 12.8333C18.3333 12.5902 18.2368 12.3571 18.0648 12.1852C17.8929 12.0132 17.6598 11.9167 17.4167 11.9167ZM17.4167 15.5833C17.2354 15.5833 17.0581 15.6371 16.9074 15.7378C16.7566 15.8385 16.6392 15.9817 16.5698 16.1492C16.5004 16.3167 16.4822 16.501 16.5176 16.6788C16.553 16.8566 16.6403 17.02 16.7685 17.1482C16.8967 17.2764 17.06 17.3637 17.2378 17.3991C17.4156 17.4344 17.6 17.4163 17.7675 17.3469C17.935 17.2775 18.0781 17.16 18.1788 17.0093C18.2796 16.8585 18.3333 16.6813 18.3333 16.5C18.3333 16.2569 18.2368 16.0237 18.0648 15.8518C17.8929 15.6799 17.6598 15.5833 17.4167 15.5833ZM17.4167 8.25C17.2354 8.25 17.0581 8.30376 16.9074 8.40449C16.7566 8.50521 16.6392 8.64837 16.5698 8.81587C16.5004 8.98337 16.4822 9.16768 16.5176 9.3455C16.553 9.52332 16.6403 9.68665 16.7685 9.81485C16.8967 9.94305 17.06 10.0304 17.2378 10.0657C17.4156 10.1011 17.6 10.0829 17.7675 10.0136C17.935 9.94418 18.0781 9.82668 18.1788 9.67594C18.2796 9.52519 18.3333 9.34797 18.3333 9.16667C18.3333 8.92355 18.2368 8.69039 18.0648 8.51849C17.8929 8.34658 17.6598 8.25 17.4167 8.25Z"/>
</svg>
`
};

export const HeroVenue: IconConfig = {
  name: `venue`,
  src: `<svg viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
<path  d="M17.25 9.49584C17.25 15.2708 10.8333 20.0833 9 20.0833C7.16667 20.0833 0.75 15.2708 0.75 9.49584C0.75 3.72084 4.44365 0.833344 9 0.833344C13.5563 0.833344 17.25 3.72084 17.25 9.49584Z" stroke-width="1.4"/>
<path d="M11.9798 8.39582C11.9798 10.0412 10.646 11.375 9.00065 11.375C7.3553 11.375 6.02148 10.0412 6.02148 8.39582C6.02148 6.75047 7.3553 5.41666 9.00065 5.41666C10.646 5.41666 11.9798 6.75047 11.9798 8.39582Z" stroke-width="1.4"/>
</svg>
`
};

export const HeroEvent: IconConfig = {
  name: `event`,
  src: `<svg viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
<path d="M1.34961 9.18793H20.6589" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.8132 13.4188H15.8232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.0046 13.4188H11.0146" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.18819 13.4188H6.19823" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.8132 17.6292H15.8232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.0046 17.6292H11.0146" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.18819 17.6292H6.19823" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.3807 1.16666V4.73167" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.62875 1.16666V4.73167" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15.5915 2.87744H6.41854C3.23713 2.87744 1.25 4.6497 1.25 7.90739V17.7112C1.25 21.0201 3.23713 22.8333 6.41854 22.8333H15.5814C18.7729 22.8333 20.75 21.0508 20.75 17.7931V7.90739C20.76 4.6497 18.7829 2.87744 15.5915 2.87744Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`
};

export const HeroStaff: IconConfig = {
  name: `staff`,
  src: `<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
<g clip-path="url(#clip0_822_841)">
<path d="M15.5827 19.25V17.4167C15.5827 16.4442 15.1964 15.5116 14.5087 14.8239C13.8211 14.1363 12.8885 13.75 11.916 13.75H4.58268C3.61022 13.75 2.67759 14.1363 1.98996 14.8239C1.30232 15.5116 0.916016 16.4442 0.916016 17.4167V19.25" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.25065 10.0833C10.2757 10.0833 11.9173 8.44171 11.9173 6.41667C11.9173 4.39162 10.2757 2.75 8.25065 2.75C6.22561 2.75 4.58398 4.39162 4.58398 6.41667C4.58398 8.44171 6.22561 10.0833 8.25065 10.0833Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M21.084 19.25V17.4167C21.0834 16.6043 20.813 15.815 20.3152 15.173C19.8175 14.5309 19.1206 14.0723 18.334 13.8692" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.666 2.86917C15.4547 3.07111 16.1538 3.52981 16.653 4.17296C17.1522 4.8161 17.4232 5.6071 17.4232 6.42125C17.4232 7.23541 17.1522 8.02641 16.653 8.66955C16.1538 9.31269 15.4547 9.7714 14.666 9.97334" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_822_841">
<rect width="22" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
`
};

export const HeroDate: IconConfig = {
  name: `date`,
  src: `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1043_1188)">
<path d="M9.5 1H9V0.5C9 0.367392 8.94732 0.240215 8.85355 0.146447C8.75979 0.0526784 8.63261 0 8.5 0C8.36739 0 8.24021 0.0526784 8.14645 0.146447C8.05268 0.240215 8 0.367392 8 0.5V1H4V0.5C4 0.367392 3.94732 0.240215 3.85355 0.146447C3.75979 0.0526784 3.63261 0 3.5 0C3.36739 0 3.24021 0.0526784 3.14645 0.146447C3.05268 0.240215 3 0.367392 3 0.5V1H2.5C1.8372 1.00079 1.20178 1.26444 0.73311 1.73311C0.264441 2.20178 0.000793929 2.8372 0 3.5L0 9.5C0.000793929 10.1628 0.264441 10.7982 0.73311 11.2669C1.20178 11.7356 1.8372 11.9992 2.5 12H9.5C10.1628 11.9992 10.7982 11.7356 11.2669 11.2669C11.7356 10.7982 11.9992 10.1628 12 9.5V3.5C11.9992 2.8372 11.7356 2.20178 11.2669 1.73311C10.7982 1.26444 10.1628 1.00079 9.5 1V1ZM1 3.5C1 3.10218 1.15804 2.72064 1.43934 2.43934C1.72064 2.15804 2.10218 2 2.5 2H9.5C9.89782 2 10.2794 2.15804 10.5607 2.43934C10.842 2.72064 11 3.10218 11 3.5V4H1V3.5ZM9.5 11H2.5C2.10218 11 1.72064 10.842 1.43934 10.5607C1.15804 10.2794 1 9.89782 1 9.5V5H11V9.5C11 9.89782 10.842 10.2794 10.5607 10.5607C10.2794 10.842 9.89782 11 9.5 11Z" fill="currentColor"/>
<path d="M6 8.25C6.41421 8.25 6.75 7.91421 6.75 7.5C6.75 7.08579 6.41421 6.75 6 6.75C5.58579 6.75 5.25 7.08579 5.25 7.5C5.25 7.91421 5.58579 8.25 6 8.25Z" fill="currentColor"/>
<path d="M3.5 8.25C3.91421 8.25 4.25 7.91421 4.25 7.5C4.25 7.08579 3.91421 6.75 3.5 6.75C3.08579 6.75 2.75 7.08579 2.75 7.5C2.75 7.91421 3.08579 8.25 3.5 8.25Z" fill="currentColor"/>
<path d="M8.5 8.25C8.91421 8.25 9.25 7.91421 9.25 7.5C9.25 7.08579 8.91421 6.75 8.5 6.75C8.08579 6.75 7.75 7.08579 7.75 7.5C7.75 7.91421 8.08579 8.25 8.5 8.25Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_1043_1188">
<rect width="12" height="12" fill="white"/>
</clipPath>
</defs>
</svg>
`
};

export const HeroSpecialPen: IconConfig = {
  name: `special-pen`,
  src: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 16.6667H17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.75 2.91666C14.0815 2.58514 14.5312 2.3989 15 2.3989C15.2321 2.3989 15.462 2.44462 15.6765 2.53346C15.891 2.6223 16.0858 2.75251 16.25 2.91666C16.4142 3.08081 16.5444 3.27569 16.6332 3.49017C16.722 3.70464 16.7678 3.93452 16.7678 4.16666C16.7678 4.39881 16.722 4.62868 16.6332 4.84316C16.5444 5.05763 16.4142 5.25251 16.25 5.41666L5.83333 15.8333L2.5 16.6667L3.33333 13.3333L13.75 2.91666Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`
};

export const HeroClose: IconConfig = {
  name: `close`,
  src: `<svg viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.75 8.25L8.25 24.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.25 8.25L24.75 24.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`
};

export const DropDown: IconConfig = {
  name: `drop-down`,
  src: `<svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.35786 6.16L0.715698 1.49729L1.373 0.839996L5.35786 4.82486L9.34272 0.839996L10 1.51783L5.35786 6.16Z" fill="currentColor"/>
</svg>


`
};

export const HeroTotal: IconConfig = {
  name: `total-outline`,
  src: `<svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" width="44" height="44" rx="22" fill="#4B9CD3" fill-opacity="0.05"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2505 20.6101C11.9535 20.9116 11.7873 21.3171 11.7873 21.7404V23.4538C11.7873 23.6576 11.9528 23.8232 12.1567 23.8232H12.8955C13.3853 23.8232 13.8553 24.0175 14.2018 24.364C14.5483 24.7105 14.7426 25.1803 14.7426 25.6703C14.7426 26.1601 14.5483 26.6301 14.2018 26.9766C13.8553 27.323 13.3855 27.5173 12.8955 27.5173H12.1567C11.9528 27.5173 11.7873 27.6829 11.7873 27.8867V29.6001C11.7873 30.027 11.9571 30.4372 12.2594 30.7393C12.5616 31.0414 12.9717 31.2115 13.3987 31.2115H31.6017C32.0287 31.2115 32.4389 31.0416 32.741 30.7393C33.0431 30.4372 33.2131 30.027 33.2131 29.6001V27.8867C33.2131 27.6829 33.0476 27.5173 32.8437 27.5173H32.1049C31.6151 27.5173 31.1451 27.3231 30.7986 26.9766C30.4521 26.6301 30.2578 26.1602 30.2578 25.6703C30.2578 25.1804 30.4521 24.7105 30.7986 24.364C31.1451 24.0175 31.615 23.8232 32.1049 23.8232H32.8437C33.0476 23.8232 33.2131 23.6576 33.2131 23.4538V22.9994L33.7429 22.0825C33.9564 21.7124 34.014 21.2727 33.904 20.8598C33.7932 20.4468 33.5227 20.0944 33.1526 19.8808L17.389 10.7797C17.0189 10.5655 16.5784 10.5077 16.1655 10.6186C15.7532 10.7287 15.4007 10.999 15.1872 11.3693C14.7829 12.069 14.3309 12.8529 14.3309 12.8529C14.229 13.0295 14.2889 13.2556 14.4661 13.3575L15.106 13.7269C15.5302 13.9715 15.8397 14.3755 15.9661 14.8485C16.0932 15.3213 16.0266 15.826 15.782 16.2501C15.5368 16.6743 15.1334 16.9839 14.6604 17.1108C14.1868 17.2372 13.683 17.1714 13.2588 16.9261L12.6189 16.5567C12.4416 16.4548 12.2162 16.5153 12.1143 16.692C12.1143 16.692 11.6614 17.4758 11.2572 18.1756C11.0436 18.5456 10.9861 18.9853 11.0961 19.3983C11.2069 19.8112 11.4774 20.1636 11.8474 20.3772L12.2502 20.6099L12.2505 20.6101ZM31.6019 20.8681H13.4356L13.0344 20.9479C12.9414 20.9908 12.8556 21.0498 12.7817 21.1237C12.6176 21.2878 12.5261 21.5094 12.5261 21.7406V23.0845H12.8955C13.5811 23.0845 14.2387 23.3571 14.7241 23.8419C15.2088 24.3272 15.4814 24.9849 15.4814 25.6704C15.4814 26.356 15.2088 27.0137 14.7241 27.499C14.2387 27.9837 13.5811 28.2563 12.8955 28.2563H12.5261V29.6002C12.5261 29.8315 12.6178 30.0531 12.7817 30.2172C12.9458 30.3813 13.1675 30.4728 13.3987 30.4728H31.6017C31.8329 30.4728 32.0546 30.3811 32.2187 30.2172C32.3828 30.0531 32.4743 29.8314 32.4743 29.6002V28.2563H32.1049C31.4193 28.2563 30.7616 27.9837 30.2763 27.499C29.7916 27.0137 29.519 26.356 29.519 25.6704C29.519 24.9849 29.7916 24.3272 30.2763 23.8419C30.7616 23.3572 31.4193 23.0845 32.1049 23.0845H32.4743V21.7405C32.4743 21.5092 32.3826 21.2876 32.2187 21.1235L32.2106 21.1154C32.048 20.9566 31.8293 20.8679 31.6017 20.8679L31.6019 20.8681ZM17.3286 28.6258H27.6722C27.8761 28.6258 28.0416 28.4602 28.0416 28.2563C28.0416 28.0525 27.8761 27.8869 27.6722 27.8869H17.3286C17.1248 27.8869 16.9592 28.0525 16.9592 28.2563C16.9592 28.4602 17.1248 28.6258 17.3286 28.6258ZM17.3286 27.1481H27.6722C27.8761 27.1481 28.0416 26.9825 28.0416 26.7787C28.0416 26.5749 27.8761 26.4093 27.6722 26.4093H17.3286C17.1248 26.4093 16.9592 26.5749 16.9592 26.7787C16.9592 26.9825 17.1248 27.1481 17.3286 27.1481ZM17.1424 22.5171H16.9443C16.6303 22.5171 16.3526 22.7196 16.2558 23.0173C16.159 23.3158 16.2647 23.6424 16.5188 23.8271L16.6791 23.943L16.6178 24.1314C16.521 24.4299 16.6267 24.7564 16.8808 24.9404C17.1343 25.1251 17.4779 25.1251 17.7312 24.9404L17.8915 24.8245L18.0518 24.9404C18.3059 25.1251 18.6494 25.1251 18.9029 24.9404C19.1564 24.7564 19.2628 24.4298 19.1659 24.1314L19.1046 23.943L19.2649 23.8271C19.5184 23.6424 19.6247 23.3159 19.5279 23.0173C19.4311 22.7197 19.1526 22.5171 18.8394 22.5171H18.6413L18.58 22.3288C18.4832 22.0311 18.2055 21.8286 17.8914 21.8286C17.5781 21.8286 17.3004 22.0311 17.2036 22.3288L17.1422 22.5171H17.1424ZM17.8916 22.6014L17.9419 22.7566C18.0394 23.0543 18.3173 23.2559 18.6305 23.2559H18.7931L18.6616 23.3519C18.4082 23.536 18.3018 23.8625 18.3986 24.161L18.4489 24.3162L18.3175 24.2202C18.064 24.0362 17.7204 24.0362 17.4671 24.2202L17.3349 24.3162L17.3852 24.161C17.4826 23.8625 17.3763 23.536 17.1229 23.3519L16.9907 23.2559H17.154C17.4673 23.2559 17.745 23.0543 17.8418 22.7566L17.8921 22.6014H17.8916ZM33.1934 21.4887C33.2297 21.3461 33.2289 21.1953 33.1905 21.0505C33.1306 20.8274 32.9843 20.6368 32.7834 20.5208L17.0198 11.4197C16.8187 11.3038 16.5809 11.2719 16.357 11.3325C16.1338 11.3923 15.9432 11.5386 15.8273 11.7388L15.1557 12.9025L15.4757 13.0872C16.0697 13.43 16.5026 13.9952 16.6799 14.6572C16.858 15.32 16.7648 16.0255 16.4219 16.6195C16.0791 17.2135 15.5139 17.6465 14.8519 17.8246C14.1891 18.0019 13.4836 17.9088 12.8896 17.566L12.5696 17.3813L11.8973 18.5449C11.782 18.7451 11.7502 18.9838 11.81 19.2077C11.8699 19.4308 12.0162 19.6215 12.217 19.7374L12.9877 20.1822C13.1206 20.1474 13.2588 20.1289 13.3985 20.1289H16.5895L16.5436 20.1024C16.367 20.0005 16.3065 19.7744 16.4084 19.5977C16.5103 19.4211 16.7364 19.3606 16.9131 19.4625L18.0671 20.1289H19.5448L17.2825 18.8226C17.1058 18.7207 17.0453 18.4946 17.1472 18.318C17.2492 18.1414 17.4753 18.0808 17.6519 18.1828L21.0225 20.1288H31.6017C31.6526 20.1288 31.7036 20.1309 31.7539 20.1362L31.7775 20.1384C31.7826 20.139 31.787 20.1398 31.7923 20.1398C31.8129 20.1428 31.8337 20.1458 31.8536 20.1488L31.8596 20.1494C31.8906 20.1545 31.9209 20.1605 31.9513 20.1672C31.9623 20.1694 31.9734 20.1723 31.9846 20.1753L32.0001 20.1789C32.0281 20.1855 32.0555 20.1938 32.0821 20.2019L32.0872 20.2033C32.0976 20.207 32.1071 20.2099 32.1167 20.2137L32.1233 20.2159C32.1396 20.221 32.1558 20.2269 32.1713 20.2329L32.1934 20.2418C32.2015 20.2447 32.2089 20.2477 32.217 20.2507C32.4112 20.3312 32.5893 20.4494 32.7407 20.601L32.7577 20.6179L32.7747 20.6358L32.791 20.6536L32.8125 20.6772L32.8435 20.7141L32.8634 20.7377L32.8783 20.7568L32.8923 20.7759L32.9063 20.7944C33.0547 20.9997 33.153 21.2377 33.1929 21.4882L33.1934 21.4887ZM19.4364 14.7194L19.2651 14.6204C18.9931 14.4637 18.6519 14.4992 18.419 14.7091C18.1855 14.9189 18.1146 15.2552 18.2418 15.5418L18.3222 15.7229L18.1751 15.8552C17.9424 16.0649 17.8707 16.4012 17.9985 16.6878C18.1257 16.9738 18.4233 17.146 18.7352 17.1126L18.9324 17.092L19.0129 17.2731C19.14 17.5597 19.4377 17.7319 19.7496 17.6986C20.0614 17.6661 20.317 17.4364 20.382 17.1296L20.4234 16.9353L20.62 16.9147C20.9318 16.8822 21.1874 16.6525 21.2524 16.3457C21.3174 16.0392 21.1779 15.7252 20.9066 15.5685L20.7344 15.4695L20.7758 15.2753C20.8408 14.9687 20.7013 14.6547 20.43 14.498C20.158 14.3413 19.8168 14.3776 19.584 14.5874L19.4362 14.7197L19.4364 14.7194ZM20.0438 15.1671L20.0098 15.3259C19.9449 15.6325 20.0844 15.9465 20.3563 16.1032L20.4967 16.1845L20.3349 16.2014C20.023 16.2348 19.7682 16.4645 19.7033 16.7711L19.6693 16.9299L19.6028 16.7814C19.4757 16.4948 19.178 16.3233 18.8661 16.356L18.7044 16.373L18.8248 16.2643C19.0583 16.0545 19.1299 15.7182 19.002 15.4324L18.9356 15.2832L19.0768 15.3645C19.3487 15.5218 19.6899 15.4857 19.9228 15.2758L20.044 15.1671L20.0438 15.1671Z" fill="#4B9CD3"/>
  <rect x="0.778125" y="0.278125" width="43.4437" height="43.4437" rx="21.7219" stroke="#4B9CD3" stroke-opacity="0.2" stroke-width="0.55625"/>
  </svg>
  `
};

export const HeroTotalActive: IconConfig = {
  name: `total-outline-active`,
  src: `<svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" width="44" height="44" rx="22" fill="black" fill-opacity="0.05"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2505 20.6101C11.9535 20.9116 11.7873 21.3171 11.7873 21.7404V23.4538C11.7873 23.6576 11.9528 23.8232 12.1567 23.8232H12.8955C13.3853 23.8232 13.8553 24.0175 14.2018 24.364C14.5483 24.7105 14.7426 25.1803 14.7426 25.6703C14.7426 26.1601 14.5483 26.6301 14.2018 26.9766C13.8553 27.323 13.3855 27.5173 12.8955 27.5173H12.1567C11.9528 27.5173 11.7873 27.6829 11.7873 27.8867V29.6001C11.7873 30.027 11.9571 30.4372 12.2594 30.7393C12.5616 31.0414 12.9717 31.2115 13.3987 31.2115H31.6017C32.0287 31.2115 32.4389 31.0416 32.741 30.7393C33.0431 30.4372 33.2131 30.027 33.2131 29.6001V27.8867C33.2131 27.6829 33.0476 27.5173 32.8437 27.5173H32.1049C31.6151 27.5173 31.1451 27.3231 30.7986 26.9766C30.4521 26.6301 30.2578 26.1602 30.2578 25.6703C30.2578 25.1804 30.4521 24.7105 30.7986 24.364C31.1451 24.0175 31.615 23.8232 32.1049 23.8232H32.8437C33.0476 23.8232 33.2131 23.6576 33.2131 23.4538V22.9994L33.7429 22.0825C33.9564 21.7124 34.014 21.2727 33.904 20.8598C33.7932 20.4468 33.5227 20.0944 33.1526 19.8808L17.389 10.7797C17.0189 10.5655 16.5784 10.5077 16.1655 10.6186C15.7532 10.7287 15.4007 10.999 15.1872 11.3693C14.7829 12.069 14.3309 12.8529 14.3309 12.8529C14.229 13.0295 14.2889 13.2556 14.4661 13.3575L15.106 13.7269C15.5302 13.9715 15.8397 14.3755 15.9661 14.8485C16.0932 15.3213 16.0266 15.826 15.782 16.2501C15.5368 16.6743 15.1334 16.9839 14.6604 17.1108C14.1868 17.2372 13.683 17.1714 13.2588 16.9261L12.6189 16.5567C12.4416 16.4548 12.2162 16.5153 12.1143 16.692C12.1143 16.692 11.6614 17.4758 11.2572 18.1756C11.0436 18.5456 10.9861 18.9853 11.0961 19.3983C11.2069 19.8112 11.4774 20.1636 11.8474 20.3772L12.2502 20.6099L12.2505 20.6101ZM31.6019 20.8681H13.4356L13.0344 20.9479C12.9414 20.9908 12.8556 21.0498 12.7817 21.1237C12.6176 21.2878 12.5261 21.5094 12.5261 21.7406V23.0845H12.8955C13.5811 23.0845 14.2387 23.3571 14.7241 23.8419C15.2088 24.3272 15.4814 24.9849 15.4814 25.6704C15.4814 26.356 15.2088 27.0137 14.7241 27.499C14.2387 27.9837 13.5811 28.2563 12.8955 28.2563H12.5261V29.6002C12.5261 29.8315 12.6178 30.0531 12.7817 30.2172C12.9458 30.3813 13.1675 30.4728 13.3987 30.4728H31.6017C31.8329 30.4728 32.0546 30.3811 32.2187 30.2172C32.3828 30.0531 32.4743 29.8314 32.4743 29.6002V28.2563H32.1049C31.4193 28.2563 30.7616 27.9837 30.2763 27.499C29.7916 27.0137 29.519 26.356 29.519 25.6704C29.519 24.9849 29.7916 24.3272 30.2763 23.8419C30.7616 23.3572 31.4193 23.0845 32.1049 23.0845H32.4743V21.7405C32.4743 21.5092 32.3826 21.2876 32.2187 21.1235L32.2106 21.1154C32.048 20.9566 31.8293 20.8679 31.6017 20.8679L31.6019 20.8681ZM17.3286 28.6258H27.6722C27.8761 28.6258 28.0416 28.4602 28.0416 28.2563C28.0416 28.0525 27.8761 27.8869 27.6722 27.8869H17.3286C17.1248 27.8869 16.9592 28.0525 16.9592 28.2563C16.9592 28.4602 17.1248 28.6258 17.3286 28.6258ZM17.3286 27.1481H27.6722C27.8761 27.1481 28.0416 26.9825 28.0416 26.7787C28.0416 26.5749 27.8761 26.4093 27.6722 26.4093H17.3286C17.1248 26.4093 16.9592 26.5749 16.9592 26.7787C16.9592 26.9825 17.1248 27.1481 17.3286 27.1481ZM17.1424 22.5171H16.9443C16.6303 22.5171 16.3526 22.7196 16.2558 23.0173C16.159 23.3158 16.2647 23.6424 16.5188 23.8271L16.6791 23.943L16.6178 24.1314C16.521 24.4299 16.6267 24.7564 16.8808 24.9404C17.1343 25.1251 17.4779 25.1251 17.7312 24.9404L17.8915 24.8245L18.0518 24.9404C18.3059 25.1251 18.6494 25.1251 18.9029 24.9404C19.1564 24.7564 19.2628 24.4298 19.1659 24.1314L19.1046 23.943L19.2649 23.8271C19.5184 23.6424 19.6247 23.3159 19.5279 23.0173C19.4311 22.7197 19.1526 22.5171 18.8394 22.5171H18.6413L18.58 22.3288C18.4832 22.0311 18.2055 21.8286 17.8914 21.8286C17.5781 21.8286 17.3004 22.0311 17.2036 22.3288L17.1422 22.5171H17.1424ZM17.8916 22.6014L17.9419 22.7566C18.0394 23.0543 18.3173 23.2559 18.6305 23.2559H18.7931L18.6616 23.3519C18.4082 23.536 18.3018 23.8625 18.3986 24.161L18.4489 24.3162L18.3175 24.2202C18.064 24.0362 17.7204 24.0362 17.4671 24.2202L17.3349 24.3162L17.3852 24.161C17.4826 23.8625 17.3763 23.536 17.1229 23.3519L16.9907 23.2559H17.154C17.4673 23.2559 17.745 23.0543 17.8418 22.7566L17.8921 22.6014H17.8916ZM33.1934 21.4887C33.2297 21.3461 33.2289 21.1953 33.1905 21.0505C33.1306 20.8274 32.9843 20.6368 32.7834 20.5208L17.0198 11.4197C16.8187 11.3038 16.5809 11.2719 16.357 11.3325C16.1338 11.3923 15.9432 11.5386 15.8273 11.7388L15.1557 12.9025L15.4757 13.0872C16.0697 13.43 16.5026 13.9952 16.6799 14.6572C16.858 15.32 16.7648 16.0255 16.4219 16.6195C16.0791 17.2135 15.5139 17.6465 14.8519 17.8246C14.1891 18.0019 13.4836 17.9088 12.8896 17.566L12.5696 17.3813L11.8973 18.5449C11.782 18.7451 11.7502 18.9838 11.81 19.2077C11.8699 19.4308 12.0162 19.6215 12.217 19.7374L12.9877 20.1822C13.1206 20.1474 13.2588 20.1289 13.3985 20.1289H16.5895L16.5436 20.1024C16.367 20.0005 16.3065 19.7744 16.4084 19.5977C16.5103 19.4211 16.7364 19.3606 16.9131 19.4625L18.0671 20.1289H19.5448L17.2825 18.8226C17.1058 18.7207 17.0453 18.4946 17.1472 18.318C17.2492 18.1414 17.4753 18.0808 17.6519 18.1828L21.0225 20.1288H31.6017C31.6526 20.1288 31.7036 20.1309 31.7539 20.1362L31.7775 20.1384C31.7826 20.139 31.787 20.1398 31.7923 20.1398C31.8129 20.1428 31.8337 20.1458 31.8536 20.1488L31.8596 20.1494C31.8906 20.1545 31.9209 20.1605 31.9513 20.1672C31.9623 20.1694 31.9734 20.1723 31.9846 20.1753L32.0001 20.1789C32.0281 20.1855 32.0555 20.1938 32.0821 20.2019L32.0872 20.2033C32.0976 20.207 32.1071 20.2099 32.1167 20.2137L32.1233 20.2159C32.1396 20.221 32.1558 20.2269 32.1713 20.2329L32.1934 20.2418C32.2015 20.2447 32.2089 20.2477 32.217 20.2507C32.4112 20.3312 32.5893 20.4494 32.7407 20.601L32.7577 20.6179L32.7747 20.6358L32.791 20.6536L32.8125 20.6772L32.8435 20.7141L32.8634 20.7377L32.8783 20.7568L32.8923 20.7759L32.9063 20.7944C33.0547 20.9997 33.153 21.2377 33.1929 21.4882L33.1934 21.4887ZM19.4364 14.7194L19.2651 14.6204C18.9931 14.4637 18.6519 14.4992 18.419 14.7091C18.1855 14.9189 18.1146 15.2552 18.2418 15.5418L18.3222 15.7229L18.1751 15.8552C17.9424 16.0649 17.8707 16.4012 17.9985 16.6878C18.1257 16.9738 18.4233 17.146 18.7352 17.1126L18.9324 17.092L19.0129 17.2731C19.14 17.5597 19.4377 17.7319 19.7496 17.6986C20.0614 17.6661 20.317 17.4364 20.382 17.1296L20.4234 16.9353L20.62 16.9147C20.9318 16.8822 21.1874 16.6525 21.2524 16.3457C21.3174 16.0392 21.1779 15.7252 20.9066 15.5685L20.7344 15.4695L20.7758 15.2753C20.8408 14.9687 20.7013 14.6547 20.43 14.498C20.158 14.3413 19.8168 14.3776 19.584 14.5874L19.4362 14.7197L19.4364 14.7194ZM20.0438 15.1671L20.0098 15.3259C19.9449 15.6325 20.0844 15.9465 20.3563 16.1032L20.4967 16.1845L20.3349 16.2014C20.023 16.2348 19.7682 16.4645 19.7033 16.7711L19.6693 16.9299L19.6028 16.7814C19.4757 16.4948 19.178 16.3233 18.8661 16.356L18.7044 16.373L18.8248 16.2643C19.0583 16.0545 19.1299 15.7182 19.002 15.4324L18.9356 15.2832L19.0768 15.3645C19.3487 15.5218 19.6899 15.4857 19.9228 15.2758L20.044 15.1671L20.0438 15.1671Z" fill="white"/>
  <rect x="0.778125" y="0.278125" width="43.4437" height="43.4437" rx="21.7219" stroke="white" stroke-opacity="0.25" stroke-width="0.55625"/>
  </svg>
  `
};

export const HeroAvailable: IconConfig = {
  name: `available-outline`,
  src: `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="44" height="44" rx="22" fill="#4B9CD3" fill-opacity="0.05"/>
  <path d="M29.4896 17.6598C29.4898 17.653 29.4916 17.6463 29.4916 17.6391L29.4918 11.4399C29.5016 11.3259 29.4612 11.2104 29.3765 11.1259C29.376 11.1253 29.3752 11.1248 29.3747 11.124C29.3633 11.1126 29.3526 11.1008 29.3393 11.0907L28.1797 10.2018C28.0374 10.093 27.8399 10.093 27.6976 10.2018L26.7799 10.9062L25.8634 10.2022C25.7211 10.0928 25.5231 10.0928 25.3808 10.2022L24.4646 10.906L23.5481 10.2022C23.4058 10.0928 23.2078 10.0928 23.0655 10.2022L22.149 10.906L21.2326 10.2022C21.0902 10.0928 20.8923 10.0928 20.7499 10.2022L19.5925 11.0912C19.4774 11.1796 19.4259 11.3188 19.4423 11.4531V16.133L15.7616 20.3744C14.9527 21.2121 14.5068 22.3159 14.5068 23.488L14.6022 30.8593L14.5072 33.4694C14.5032 33.5768 14.5433 33.6814 14.6179 33.7587C14.6925 33.8361 14.7954 33.8799 14.9029 33.8799H20.0344C20.144 33.8799 20.2492 33.8344 20.3237 33.7543C20.3987 33.674 20.437 33.5663 20.4293 33.4571L20.2558 30.9003L20.3179 30.6582C20.5287 29.8356 20.7825 29.4186 21.4497 28.7988C22.2279 28.0756 22.9573 27.0805 23.2228 26.3791C23.2269 26.3693 23.23 26.3592 23.2328 26.349L23.4295 25.6706C23.4856 25.6585 23.5403 25.6384 23.5882 25.6014L24.4959 24.9001L25.405 25.6016C25.4763 25.6564 25.5616 25.6842 25.6468 25.6842C25.7321 25.6842 25.8177 25.6568 25.889 25.6016L26.7967 24.9003L27.7062 25.6017C27.8486 25.7115 28.0478 25.7119 28.1902 25.6016L29.3397 24.7134C29.4535 24.6255 29.5048 24.4876 29.4894 24.3543V17.6595L29.4896 17.6598ZM19.5613 23.2966C19.4396 23.2359 19.3401 23.1361 19.2788 23.0038C19.1956 22.8241 19.191 22.6153 19.2659 22.431C19.3678 22.1807 19.4668 21.951 19.5617 21.74L19.5613 23.2966ZM20.9104 28.2193C20.1845 28.8935 19.8491 29.4168 19.6046 30.2706H17.0504C16.8683 30.2706 16.7204 30.4185 16.7204 30.6006C16.7204 30.7827 16.8683 30.9306 17.0504 30.9306H19.464L19.6104 33.0884H15.3135L15.3919 30.9302H16.0396C16.2217 30.9302 16.3696 30.7823 16.3696 30.6002C16.3696 30.4181 16.2217 30.2702 16.0396 30.2702H15.3864L15.2986 23.483C15.2986 22.5223 15.6652 21.6139 16.3453 20.9093L19.563 17.2027L19.5622 20.325C19.26 20.7671 18.9067 21.5641 18.6551 22.182C18.5109 22.535 18.5199 22.9353 18.68 23.281C18.8312 23.608 19.0982 23.8484 19.433 23.9585C19.4827 23.9745 19.5339 23.9878 19.5875 23.9988L20.0342 24.0881C20.0532 24.0922 20.0727 24.094 20.0926 24.0944C20.8051 24.1194 21.4084 23.6509 21.5741 23.2134C21.806 22.7232 22.2717 21.7538 22.4157 21.5048C22.549 21.2743 22.6903 21.0932 22.8358 20.9662C23.0835 20.7494 23.3484 20.6476 23.511 20.7067C23.5943 20.7373 23.8477 20.831 23.8477 21.2813C23.8477 21.3426 23.8392 21.4043 23.8237 21.4603C23.8237 21.4603 22.9349 24.5154 22.8306 24.8807C22.829 24.8868 22.8306 24.8927 22.8293 24.8984L22.4774 26.1131C22.2482 26.7031 21.592 27.5854 20.9105 28.2192L20.9104 28.2193ZM27.9479 24.7884L27.0383 24.0869C26.896 23.9772 26.6967 23.9768 26.5544 24.0871L25.6467 24.7884L24.7375 24.0869C24.5952 23.9772 24.3959 23.9768 24.2536 24.0871L23.6009 24.5913C23.879 23.6324 24.4574 21.6443 24.4584 21.6412C24.4908 21.5235 24.5075 21.4025 24.5075 21.2819C24.5075 20.7037 24.2274 20.2687 23.7382 20.0879C23.335 19.9413 22.8473 20.08 22.4016 20.4702C22.2014 20.645 22.0139 20.8823 21.8449 21.1751C21.6493 21.5125 20.9991 22.8874 20.9713 22.9458C20.9663 22.9561 20.962 22.9666 20.958 22.9774C20.907 23.1229 20.6098 23.3866 20.2218 23.4273L20.2225 20.3838V20.3807L20.2236 16.3073C20.2304 16.278 20.235 16.2482 20.235 16.2167V14.1413H20.4227C20.6048 14.1413 20.7527 13.9934 20.7527 13.8113C20.7527 13.6292 20.6048 13.4813 20.4227 13.4813H20.235V11.598L20.9919 11.0164L21.9083 11.7203C22.0506 11.8297 22.2486 11.8297 22.3909 11.7203L23.3074 11.0164L24.2239 11.7203C24.3663 11.8297 24.5642 11.8297 24.7066 11.7203L25.6227 11.0164L26.5392 11.7203C26.6816 11.8297 26.8792 11.8293 27.0215 11.7205L27.9392 11.0161L28.7003 11.5999V13.4813H28.5662C28.3841 13.4813 28.2362 13.6292 28.2362 13.8113C28.2362 13.9935 28.3841 14.1413 28.5662 14.1413H28.7003V17.6198C28.7001 17.6266 28.6982 17.6332 28.6982 17.64V24.2094L27.9479 24.7884Z" fill="#4B9CD3"/>
  <path d="M25.0753 13.4806H23.9118C23.7297 13.4806 23.5818 13.6285 23.5818 13.8106C23.5818 13.9927 23.7297 14.1406 23.9118 14.1406H25.0753C25.2574 14.1406 25.4053 13.9927 25.4053 13.8106C25.4053 13.6285 25.2578 13.4806 25.0753 13.4806Z" fill="#4B9CD3"/>
  <path d="M22.7484 13.4806H21.5851C21.403 13.4806 21.2551 13.6285 21.2551 13.8106C21.2551 13.9927 21.403 14.1406 21.5851 14.1406H22.7482C22.9304 14.1406 23.0782 13.9927 23.0782 13.8106C23.0784 13.6285 22.9305 13.4806 22.7484 13.4806H22.7484Z" fill="#4B9CD3"/>
  <path d="M27.4016 13.4806H26.2384C26.0563 13.4806 25.9084 13.6285 25.9084 13.8106C25.9084 13.9927 26.0563 14.1406 26.2384 14.1406H27.4016C27.5837 14.1406 27.7316 13.9927 27.7316 13.8106C27.7316 13.6285 27.5839 13.4806 27.4016 13.4806Z" fill="#4B9CD3"/>
  <rect x="0.275" y="0.275" width="43.45" height="43.45" rx="21.725" stroke="#4B9CD3" stroke-opacity="0.2" stroke-width="0.55"/>
  </svg>`
};

export const HeroAvailableActive: IconConfig = {
  name: 'available-outline-active',
  src: `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="44" height="44" rx="22" fill="black" fill-opacity="0.05"/>
  <path d="M29.4896 17.6598C29.4898 17.653 29.4916 17.6463 29.4916 17.6391L29.4918 11.4399C29.5016 11.3259 29.4612 11.2104 29.3765 11.1259C29.376 11.1253 29.3752 11.1248 29.3747 11.124C29.3633 11.1126 29.3526 11.1008 29.3393 11.0907L28.1797 10.2018C28.0374 10.093 27.8399 10.093 27.6976 10.2018L26.7799 10.9062L25.8634 10.2022C25.7211 10.0928 25.5231 10.0928 25.3808 10.2022L24.4646 10.906L23.5481 10.2022C23.4058 10.0928 23.2078 10.0928 23.0655 10.2022L22.149 10.906L21.2326 10.2022C21.0902 10.0928 20.8923 10.0928 20.7499 10.2022L19.5925 11.0912C19.4774 11.1796 19.4259 11.3188 19.4423 11.4531V16.133L15.7616 20.3744C14.9527 21.2121 14.5068 22.3159 14.5068 23.488L14.6022 30.8593L14.5072 33.4694C14.5032 33.5768 14.5433 33.6814 14.6179 33.7587C14.6925 33.8361 14.7954 33.8799 14.9029 33.8799H20.0344C20.144 33.8799 20.2492 33.8344 20.3237 33.7543C20.3987 33.674 20.437 33.5663 20.4293 33.4571L20.2558 30.9003L20.3179 30.6582C20.5287 29.8356 20.7825 29.4186 21.4497 28.7988C22.2279 28.0756 22.9573 27.0805 23.2228 26.3791C23.2269 26.3693 23.23 26.3592 23.2328 26.349L23.4295 25.6706C23.4856 25.6585 23.5403 25.6384 23.5882 25.6014L24.4959 24.9001L25.405 25.6016C25.4763 25.6564 25.5616 25.6842 25.6468 25.6842C25.7321 25.6842 25.8177 25.6568 25.889 25.6016L26.7967 24.9003L27.7062 25.6017C27.8486 25.7115 28.0478 25.7119 28.1902 25.6016L29.3397 24.7134C29.4535 24.6255 29.5048 24.4876 29.4894 24.3543V17.6595L29.4896 17.6598ZM19.5613 23.2966C19.4396 23.2359 19.3401 23.1361 19.2788 23.0038C19.1956 22.8241 19.191 22.6153 19.2659 22.431C19.3678 22.1807 19.4668 21.951 19.5617 21.74L19.5613 23.2966ZM20.9104 28.2193C20.1845 28.8935 19.8491 29.4168 19.6046 30.2706H17.0504C16.8683 30.2706 16.7204 30.4185 16.7204 30.6006C16.7204 30.7827 16.8683 30.9306 17.0504 30.9306H19.464L19.6104 33.0884H15.3135L15.3919 30.9302H16.0396C16.2217 30.9302 16.3696 30.7823 16.3696 30.6002C16.3696 30.4181 16.2217 30.2702 16.0396 30.2702H15.3864L15.2986 23.483C15.2986 22.5223 15.6652 21.6139 16.3453 20.9093L19.563 17.2027L19.5622 20.325C19.26 20.7671 18.9067 21.5641 18.6551 22.182C18.5109 22.535 18.5199 22.9353 18.68 23.281C18.8312 23.608 19.0982 23.8484 19.433 23.9585C19.4827 23.9745 19.5339 23.9878 19.5875 23.9988L20.0342 24.0881C20.0532 24.0922 20.0727 24.094 20.0926 24.0944C20.8051 24.1194 21.4084 23.6509 21.5741 23.2134C21.806 22.7232 22.2717 21.7538 22.4157 21.5048C22.549 21.2743 22.6903 21.0932 22.8358 20.9662C23.0835 20.7494 23.3484 20.6476 23.511 20.7067C23.5943 20.7373 23.8477 20.831 23.8477 21.2813C23.8477 21.3426 23.8392 21.4043 23.8237 21.4603C23.8237 21.4603 22.9349 24.5154 22.8306 24.8807C22.829 24.8868 22.8306 24.8927 22.8293 24.8984L22.4774 26.1131C22.2482 26.7031 21.592 27.5854 20.9105 28.2192L20.9104 28.2193ZM27.9479 24.7884L27.0383 24.0869C26.896 23.9772 26.6967 23.9768 26.5544 24.0871L25.6467 24.7884L24.7375 24.0869C24.5952 23.9772 24.3959 23.9768 24.2536 24.0871L23.6009 24.5913C23.879 23.6324 24.4574 21.6443 24.4584 21.6412C24.4908 21.5235 24.5075 21.4025 24.5075 21.2819C24.5075 20.7037 24.2274 20.2687 23.7382 20.0879C23.335 19.9413 22.8473 20.08 22.4016 20.4702C22.2014 20.645 22.0139 20.8823 21.8449 21.1751C21.6493 21.5125 20.9991 22.8874 20.9713 22.9458C20.9663 22.9561 20.962 22.9666 20.958 22.9774C20.907 23.1229 20.6098 23.3866 20.2218 23.4273L20.2225 20.3838V20.3807L20.2236 16.3073C20.2304 16.278 20.235 16.2482 20.235 16.2167V14.1413H20.4227C20.6048 14.1413 20.7527 13.9934 20.7527 13.8113C20.7527 13.6292 20.6048 13.4813 20.4227 13.4813H20.235V11.598L20.9919 11.0164L21.9083 11.7203C22.0506 11.8297 22.2486 11.8297 22.3909 11.7203L23.3074 11.0164L24.2239 11.7203C24.3663 11.8297 24.5642 11.8297 24.7066 11.7203L25.6227 11.0164L26.5392 11.7203C26.6816 11.8297 26.8792 11.8293 27.0215 11.7205L27.9392 11.0161L28.7003 11.5999V13.4813H28.5662C28.3841 13.4813 28.2362 13.6292 28.2362 13.8113C28.2362 13.9935 28.3841 14.1413 28.5662 14.1413H28.7003V17.6198C28.7001 17.6266 28.6982 17.6332 28.6982 17.64V24.2094L27.9479 24.7884Z" fill="white"/>
  <path d="M25.0753 13.4806H23.9118C23.7297 13.4806 23.5818 13.6285 23.5818 13.8106C23.5818 13.9927 23.7297 14.1406 23.9118 14.1406H25.0753C25.2574 14.1406 25.4053 13.9927 25.4053 13.8106C25.4053 13.6285 25.2578 13.4806 25.0753 13.4806Z" fill="white"/>
  <path d="M22.7483 13.4806H21.585C21.4029 13.4806 21.255 13.6285 21.255 13.8106C21.255 13.9927 21.4029 14.1406 21.585 14.1406H22.7481C22.9302 14.1406 23.0781 13.9927 23.0781 13.8106C23.0783 13.6285 22.9304 13.4806 22.7483 13.4806H22.7483Z" fill="white"/>
  <path d="M27.4017 13.4806H26.2386C26.0564 13.4806 25.9086 13.6285 25.9086 13.8106C25.9086 13.9927 26.0564 14.1406 26.2386 14.1406H27.4017C27.5838 14.1406 27.7317 13.9927 27.7317 13.8106C27.7317 13.6285 27.584 13.4806 27.4017 13.4806Z" fill="white"/>
  <rect x="0.275" y="0.275" width="43.45" height="43.45" rx="21.725" stroke="white" stroke-opacity="0.25" stroke-width="0.55"/>
  </svg>
  `
};

export const HeroNotCheckedInActive: IconConfig = {
  name: `not-checked-in-outline-active`,
  src: `<svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" width="44" height="44" rx="22" fill="black" fill-opacity="0.05"/>
  <path d="M31.8155 25.9587C31.6152 25.8637 31.3754 25.9483 31.2793 26.1483C31.1342 26.4508 30.9729 26.7493 30.7993 27.0355H30.7995C29.7004 28.8483 28.0383 30.2515 26.0673 31.0309C24.096 31.8105 21.924 31.9233 19.8825 31.3525C17.8412 30.7817 16.0427 29.5584 14.7618 27.8693C13.4806 26.1804 12.7874 24.1186 12.7878 21.9984C12.7878 21.7484 12.7878 21.4943 12.816 21.2443C12.8443 20.9942 12.8524 20.841 12.8805 20.6433V20.6435C12.9116 20.423 12.7583 20.219 12.5377 20.1878C12.4301 20.1731 12.3208 20.2022 12.2351 20.2692C12.1493 20.336 12.0942 20.4347 12.0821 20.5427C12.0539 20.7483 12.0136 20.9661 12.0136 21.184C12.0136 21.4501 11.9813 21.7284 11.9813 21.9905C11.979 24.2873 12.7284 26.5217 14.1152 28.3527C15.502 30.1835 17.4499 31.51 19.6613 32.1293C21.8725 32.7488 24.226 32.6273 26.3617 31.7831C28.4975 30.9391 30.2984 29.419 31.4893 27.4552C31.6787 27.1448 31.851 26.8243 32.0054 26.4953C32.1006 26.2949 32.0159 26.0551 31.8159 25.9589L31.8155 25.9587Z" fill="white"/>
  <path d="M32.2151 24.6037C31.9924 24.5524 31.7703 24.6913 31.7191 24.9142C31.6678 25.1369 31.8068 25.3589 32.0297 25.4102C32.0711 25.416 32.1132 25.416 32.1546 25.4102C32.329 25.4101 32.4836 25.2977 32.5376 25.1319C32.5418 25.108 32.5418 25.0833 32.5376 25.0594C32.5697 24.8455 32.4273 24.6446 32.2151 24.6037L32.2151 24.6037Z" fill="white"/>
  <path d="M22.4965 11.481C20.4005 11.4765 18.3514 12.1003 16.6136 13.272C14.8756 14.4436 13.5288 16.1095 12.7468 18.0546C12.6789 18.2566 12.7801 18.4767 12.9775 18.5568C13.175 18.6369 13.4008 18.5494 13.4928 18.3571C14.3361 16.2671 15.8803 14.5355 17.8602 13.4592C19.8401 12.3829 22.1329 12.029 24.3454 12.4582C26.5577 12.8872 28.5519 14.0726 29.9864 15.811C31.4205 17.5495 32.2056 19.7328 32.2067 21.9865C32.2063 22.5189 32.1631 23.0502 32.0776 23.5755C32.0412 23.7948 32.1892 24.0022 32.4083 24.0393H32.4769C32.6767 24.0418 32.8482 23.8978 32.8801 23.7005C33.2102 21.6869 32.9476 19.6208 32.1242 17.754C31.3009 15.887 29.9524 14.3001 28.243 13.1863C26.5336 12.0725 24.5371 11.48 22.4969 11.481L22.4965 11.481Z" fill="white"/>
  <path d="M12.6453 19.736H12.734C12.9273 19.7404 13.0966 19.6066 13.1372 19.4174C13.1626 19.3131 13.1455 19.203 13.0894 19.1113C13.0334 19.0199 12.9432 18.9543 12.8388 18.9295C12.6251 18.8728 12.4059 18.9988 12.3468 19.2118V19.2319C12.3164 19.3385 12.3311 19.4528 12.3875 19.5483C12.444 19.6435 12.5373 19.7116 12.6453 19.736H12.6453Z" fill="white"/>
  <path d="M19.2299 25.6604C19.3053 25.7373 19.4085 25.7809 19.5161 25.7814C19.6239 25.7809 19.7271 25.7373 19.8025 25.6604L22.496 22.9624L25.1855 25.6482C25.3427 25.8046 25.5969 25.8046 25.754 25.6482C25.9104 25.491 25.9104 25.237 25.754 25.0796L23.0605 22.4017L25.7459 19.7361C25.8222 19.6603 25.8653 19.5573 25.8653 19.4498C25.8653 19.3422 25.8222 19.2392 25.7459 19.1634C25.5888 19.0071 25.3348 19.0071 25.1774 19.1634L22.496 21.8332L19.8106 19.1433C19.6468 18.9829 19.3841 18.9857 19.2238 19.1494C19.0635 19.313 19.0662 19.5757 19.2299 19.7361L21.9194 22.4219L19.2299 25.0916C19.0734 25.249 19.0734 25.503 19.2299 25.6604L19.2299 25.6604Z" fill="white"/>
  <rect x="0.778125" y="0.278125" width="43.4437" height="43.4437" rx="21.7219" stroke="white" stroke-opacity="0.25" stroke-width="0.55625"/>
  </svg>
  `
};

export const HeroNotCheckedIn: IconConfig = {
  name: `not-checked-in-outline`,
  src: `<svg width="45" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.5" width="44" height="44" rx="22" fill="#4B9CD3" fill-opacity="0.05"/>
  <path d="M31.8155 25.9587C31.6152 25.8637 31.3754 25.9483 31.2793 26.1483C31.1342 26.4508 30.9729 26.7493 30.7993 27.0355H30.7995C29.7004 28.8483 28.0383 30.2515 26.0673 31.0309C24.096 31.8105 21.924 31.9233 19.8825 31.3525C17.8412 30.7817 16.0427 29.5584 14.7618 27.8693C13.4806 26.1804 12.7874 24.1186 12.7878 21.9984C12.7878 21.7484 12.7878 21.4943 12.816 21.2443C12.8443 20.9942 12.8524 20.841 12.8805 20.6433V20.6435C12.9116 20.423 12.7583 20.219 12.5377 20.1878C12.4301 20.1731 12.3208 20.2022 12.2351 20.2692C12.1493 20.336 12.0942 20.4347 12.0821 20.5427C12.0539 20.7483 12.0136 20.9661 12.0136 21.184C12.0136 21.4501 11.9813 21.7284 11.9813 21.9905C11.979 24.2873 12.7284 26.5217 14.1152 28.3527C15.502 30.1835 17.4499 31.51 19.6613 32.1293C21.8725 32.7488 24.226 32.6273 26.3617 31.7831C28.4975 30.9391 30.2984 29.419 31.4893 27.4552C31.6787 27.1448 31.851 26.8243 32.0054 26.4953C32.1006 26.2949 32.0159 26.0551 31.8159 25.9589L31.8155 25.9587Z" fill="#4B9CD3"/>
  <path d="M32.2151 24.6037C31.9924 24.5524 31.7703 24.6913 31.7191 24.9142C31.6678 25.1369 31.8068 25.3589 32.0296 25.4102C32.071 25.416 32.1132 25.416 32.1546 25.4102C32.329 25.4101 32.4836 25.2977 32.5376 25.1319C32.5418 25.108 32.5418 25.0833 32.5376 25.0594C32.5697 24.8455 32.4273 24.6446 32.215 24.6037L32.2151 24.6037Z" fill="#4B9CD3"/>
  <path d="M22.4965 11.481C20.4005 11.4765 18.3514 12.1003 16.6136 13.272C14.8756 14.4436 13.5288 16.1095 12.7468 18.0546C12.6789 18.2566 12.7801 18.4767 12.9775 18.5568C13.175 18.6369 13.4008 18.5494 13.4928 18.3571C14.3361 16.2671 15.8803 14.5355 17.8602 13.4592C19.8401 12.3829 22.1329 12.029 24.3454 12.4582C26.5577 12.8872 28.5519 14.0726 29.9864 15.811C31.4205 17.5495 32.2056 19.7328 32.2067 21.9865C32.2063 22.5189 32.1631 23.0502 32.0776 23.5755C32.0412 23.7948 32.1892 24.0022 32.4083 24.0393H32.4769C32.6767 24.0418 32.8482 23.8978 32.8801 23.7005C33.2102 21.6869 32.9476 19.6208 32.1242 17.754C31.3009 15.887 29.9524 14.3001 28.243 13.1863C26.5336 12.0725 24.5371 11.48 22.4969 11.481L22.4965 11.481Z" fill="#4B9CD3"/>
  <path d="M12.6453 19.736H12.734C12.9274 19.7404 13.0966 19.6066 13.1373 19.4174C13.1627 19.3131 13.1456 19.203 13.0894 19.1113C13.0334 19.0199 12.9432 18.9543 12.8388 18.9295C12.6251 18.8728 12.4059 18.9988 12.3468 19.2118V19.2319C12.3164 19.3385 12.3312 19.4528 12.3875 19.5483C12.444 19.6435 12.5373 19.7116 12.6453 19.736H12.6453Z" fill="#4B9CD3"/>
  <path d="M19.2299 25.6604C19.3053 25.7373 19.4085 25.7809 19.5161 25.7814C19.624 25.7809 19.7271 25.7373 19.8025 25.6604L22.496 22.9624L25.1856 25.6482C25.3427 25.8046 25.5969 25.8046 25.754 25.6482C25.9105 25.491 25.9105 25.237 25.754 25.0796L23.0605 22.4017L25.7459 19.7361C25.8223 19.6603 25.8653 19.5573 25.8653 19.4498C25.8653 19.3422 25.8223 19.2392 25.7459 19.1634C25.5888 19.0071 25.3348 19.0071 25.1775 19.1634L22.496 21.8332L19.8106 19.1433C19.6468 18.9829 19.3842 18.9857 19.2238 19.1494C19.0636 19.313 19.0663 19.5757 19.2299 19.7361L21.9194 22.4219L19.2299 25.0916C19.0735 25.249 19.0735 25.503 19.2299 25.6604L19.2299 25.6604Z" fill="#4B9CD3"/>
  <rect x="0.778125" y="0.278125" width="43.4437" height="43.4437" rx="21.7219" stroke="#4B9CD3" stroke-opacity="0.2" stroke-width="0.55625"/>
  </svg>`
};

export const HeroCheckedInActive: IconConfig = {
  name: `checked-in-outline-active`,
  src: `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="44" height="44" rx="22" fill="black" fill-opacity="0.05"/>
  <path d="M20.3763 25.5542C20.5547 25.717 20.7861 25.8073 21.0261 25.8078H21.0814C21.3409 25.7938 21.5843 25.6752 21.7572 25.4784L26.6311 19.8805L25.169 18.5635L20.9449 23.4139L18.4269 21.1089L17.1273 22.5776L20.3763 25.5542Z" fill="white"/>
  <path d="M13.8777 22.5147C13.8777 23.0602 13.4412 23.5026 12.9029 23.5026C12.3646 23.5026 11.9281 23.0602 11.9281 22.5147C11.9281 21.9691 12.3646 21.5267 12.9029 21.5267C13.4412 21.5267 13.8777 21.9691 13.8777 22.5147Z" fill="white"/>
  <path d="M15.1773 27.1247C15.1773 27.6704 14.741 28.1126 14.2027 28.1126C13.6642 28.1126 13.2279 27.6704 13.2279 27.1247C13.2279 26.5791 13.6642 26.137 14.2027 26.137C14.741 26.137 15.1773 26.5791 15.1773 27.1247Z" fill="white"/>
  <path d="M15.1773 17.9046C15.1773 18.4501 14.741 18.8923 14.2027 18.8923C13.6642 18.8923 13.2279 18.4501 13.2279 17.9046C13.2279 17.3588 13.6642 16.9166 14.2027 16.9166C14.741 16.9166 15.1773 17.3588 15.1773 17.9046Z" fill="white"/>
  <path d="M18.4279 14.6118C18.4279 15.1574 17.9916 15.5995 17.4533 15.5995C16.9148 15.5995 16.4785 15.1574 16.4785 14.6118C16.4785 14.0661 16.9148 13.6239 17.4533 13.6239C17.9916 13.6239 18.4279 14.0661 18.4279 14.6118Z" fill="white"/>
  <path d="M22 12.3066V14.2825C24.902 14.2825 27.5837 15.8516 29.0346 18.3986C30.4858 20.9457 30.4858 24.0838 29.0346 26.6309C27.5836 29.1779 24.9019 30.747 22 30.747V32.7229C24.6715 32.7229 27.2335 31.6472 29.1222 29.7329C31.0111 27.8186 32.0725 25.2222 32.0725 22.515C32.0725 19.8078 31.0111 17.2111 29.1222 15.2971C27.2333 13.3828 24.6713 12.3071 22 12.3071V12.3066Z" fill="white"/>
  <path d="M18.4279 30.4176C18.4279 30.9634 17.9916 31.4056 17.4533 31.4056C16.9148 31.4056 16.4785 30.9634 16.4785 30.4176C16.4785 29.8721 16.9148 29.4299 17.4533 29.4299C17.9916 29.4299 18.4279 29.8721 18.4279 30.4176Z" fill="white"/>
  <rect x="0.275" y="0.275" width="43.45" height="43.45" rx="21.725" stroke="white" stroke-opacity="0.25" stroke-width="0.55"/>
  </svg>`
};

export const HeroCheckedIn: IconConfig = {
  name: `checked-in-outline`,
  src: `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="44" height="44" rx="22" fill="#4B9CD3" fill-opacity="0.05"/>
  <path d="M20.3763 25.5542C20.5547 25.717 20.7861 25.8073 21.0261 25.8078H21.0814C21.3409 25.7938 21.5843 25.6752 21.7572 25.4784L26.6311 19.8805L25.169 18.5635L20.9449 23.4139L18.4269 21.1089L17.1273 22.5776L20.3763 25.5542Z" fill="#4B9CD3"/>
  <path d="M13.8777 22.5147C13.8777 23.0602 13.4412 23.5026 12.9029 23.5026C12.3646 23.5026 11.9281 23.0602 11.9281 22.5147C11.9281 21.9691 12.3646 21.5267 12.9029 21.5267C13.4412 21.5267 13.8777 21.9691 13.8777 22.5147Z" fill="#4B9CD3"/>
  <path d="M15.1773 27.1247C15.1773 27.6704 14.741 28.1126 14.2027 28.1126C13.6642 28.1126 13.2279 27.6704 13.2279 27.1247C13.2279 26.5791 13.6642 26.137 14.2027 26.137C14.741 26.137 15.1773 26.5791 15.1773 27.1247Z" fill="#4B9CD3"/>
  <path d="M15.1773 17.9046C15.1773 18.4501 14.741 18.8923 14.2027 18.8923C13.6642 18.8923 13.2279 18.4501 13.2279 17.9046C13.2279 17.3588 13.6642 16.9166 14.2027 16.9166C14.741 16.9166 15.1773 17.3588 15.1773 17.9046Z" fill="#4B9CD3"/>
  <path d="M18.4279 14.6118C18.4279 15.1574 17.9916 15.5995 17.4533 15.5995C16.9148 15.5995 16.4785 15.1574 16.4785 14.6118C16.4785 14.0661 16.9148 13.6239 17.4533 13.6239C17.9916 13.6239 18.4279 14.0661 18.4279 14.6118Z" fill="#4B9CD3"/>
  <path d="M22 12.3066V14.2825C24.902 14.2825 27.5837 15.8516 29.0346 18.3986C30.4858 20.9457 30.4858 24.0838 29.0346 26.6309C27.5836 29.1779 24.9019 30.747 22 30.747V32.7229C24.6715 32.7229 27.2335 31.6472 29.1222 29.7329C31.0111 27.8186 32.0725 25.2222 32.0725 22.515C32.0725 19.8078 31.0111 17.2111 29.1222 15.2971C27.2333 13.3828 24.6713 12.3071 22 12.3071V12.3066Z" fill="#4B9CD3"/>
  <path d="M18.4279 30.4176C18.4279 30.9634 17.9916 31.4056 17.4533 31.4056C16.9148 31.4056 16.4785 30.9634 16.4785 30.4176C16.4785 29.8721 16.9148 29.4299 17.4533 29.4299C17.9916 29.4299 18.4279 29.8721 18.4279 30.4176Z" fill="#4B9CD3"/>
  <rect x="0.275" y="0.275" width="43.45" height="43.45" rx="21.725" stroke="#4B9CD3" stroke-opacity="0.2" stroke-width="0.55"/>
  </svg>`
};
export const HeroMailSend: IconConfig = {
  name: `mail-send-outline`,
  src: `<svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.5125 12.2312L12.725 11.4437L14.0938 10.0562H10.7V8.93125H14.0938L12.725 7.54375L13.5125 6.75625L16.25 9.49375L13.5125 12.2312ZM1.625 10.75C1.3125 10.75 1.04688 10.6406 0.828125 10.4219C0.609375 10.2031 0.5 9.9375 0.5 9.625V1.375C0.5 1.0625 0.609375 0.796875 0.828125 0.578125C1.04688 0.359375 1.3125 0.25 1.625 0.25H12.125C12.4375 0.25 12.7031 0.359375 12.9219 0.578125C13.1406 0.796875 13.25 1.0625 13.25 1.375V4.75H12.125V2.25625L6.8 6.025L1.625 2.275V9.625H8.75V10.75H1.625ZM2.3 1.375L6.8 4.6375L11.4125 1.375H2.3Z" fill="#4B9CD3"/>
  </svg>
  `
};
